import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { createInitOptions } from '@org/i18n';

let initPromise: Promise<typeof i18next> | null = null;

export const ensureCommunityI18n = () => {
  if (!initPromise) {
    initPromise = i18next.use(initReactI18next).init(createInitOptions({ ns: ['community'], defaultNS: 'community' }));
  }
  return initPromise;
};

export default i18next;
